'use client';

import { useEffect, useState } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { useCurrentUser } from '@/providers/CurrentUserProvider';

export default function MentorOnboardingRedirect() {
  const pathname = usePathname();
  const router = useRouter();
  const { user } = useCurrentUser();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    // Don't check if user is not logged in or not an approved mentor
    if (!user?.id || !user?.isMentorApproved) {
      return;
    }

    // Don't check if already on the welcome page or auth pages
    if (
      pathname === '/mentoring/special-welcome' ||
      pathname?.startsWith('/auth/') ||
      pathname?.startsWith('/api/') ||
      checked
    ) {
      return;
    }

    async function checkOnboarding() {
      try {
        const response = await fetch('/api/user/check-mentor-onboarding');
        const data = await response.json();

        if (data.needsOnboarding) {
          router.push('/mentoring/special-welcome');
        }
      } catch (error) {
        console.error('Error checking mentor onboarding:', error);
      } finally {
        setChecked(true);
      }
    }

    checkOnboarding();
  }, [pathname, router, checked, user]);

  return null; // This component doesn't render anything
}
